import { render, staticRenderFns } from "./CollectionPagination.vue?vue&type=template&id=664c719d&lang=pug&"
import script from "./CollectionPagination.vue?vue&type=script&lang=js&"
export * from "./CollectionPagination.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPagination.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664c719d')) {
      api.createRecord('664c719d', component.options)
    } else {
      api.reload('664c719d', component.options)
    }
    module.hot.accept("./CollectionPagination.vue?vue&type=template&id=664c719d&lang=pug&", function () {
      api.rerender('664c719d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/CollectionPagination.vue"
export default component.exports